import React from 'react';
import { Upload } from 'antd';

export default function CustomUpload({ children, ...props }) {
	return (
		<>
			<Upload {...props}>{children}</Upload>
		</>
	);
}
